import { pathJoin } from '../../../../utils'
import { createRouteMap as createCreateRouteMap } from '../../../../../../components/main/routes/settings/v2/projects/create'

export const createProjectsDetailView = (prefix: string) => ({
  create: pathJoin(prefix)('create').chainMapAuto(createCreateRouteMap),
})
